<puro-modal
  class="review-payment-notice-dialog__modal"
  [className]="'review-payment-notice-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="medium"
  [showCloseButton]="false"
  [closeOnBackdrop]="true"
  [actions]="actions()"
  (closeModal)="onDismiss()"
>
  <puro-typography
    component="p"
    variant="body1"
    class="review-payment-notice-dialog__body"
    [attr.data-testid]="messageTestId()"
  >
    @if (message()) {
      {{ message() }}
    } @else {
      {{ bodyKey() | translate }}
    }
  </puro-typography>
</puro-modal>
